import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "../../../../components/Dynamic_FilterForm";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";

const ReimburseComponent = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  isSrNoRequired,
  isApiStatus,
  isRequiredStatus,
  handleReset,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  handleModalColumn,
  handleColumnSelect,
  icons,
  isActionRequired,
  isFileDownloadRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible;
      return acc;
    }, {})
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });



  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();
  const sortedData = useMemo(() => {
    let sortableItems = Array.isArray(data) ? [...data] : [];

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);

          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending"
                ? numA - numB
                : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }

        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return ""; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY",
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };

  const [dropDownValue, setDropdownValue] = useState({});

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

    const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
    const handleRecordsPerPage = (e) => {
      const newRecordsPerPage = Number(e.target.value);
  
      // Calculate the new starting record index based on the current page
      const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
      const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  
      // Update state
      setSelectedRecordsPerPage(newRecordsPerPage);
      setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
      setItemsPerPage(newRecordsPerPage);
    };
  const handleDownload = async (fileUrl) => {
    try {
      if (fileUrl) {
        // Create a temporary anchor element to trigger the download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileUrl.split("/").pop(); // Extract file name from URL
        link.style.display = "none"; // Hide the link element
        document.body.appendChild(link);
        link.click(); // Trigger the click event to start download
        document.body.removeChild(link); // Remove the link after the click
      } else {
        console.error("File URL is empty or undefined.");
      }
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <div className="container-fluid ">
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleReset={handleReset}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
          >
            <div className="me-1">
              <ExportToExcel
                data={currentData}
                filename={`${ExcelName}.csv`}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
          >
            <div className="btn-group me-2">
              <button
                type="button"
                className="dropdown-toggle skill-button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="excel-btn"
              >
                <i className="bi bi-list"></i>
              </button>
              <ul className="dropdown-menu p-2">
                <div className="row">
                  <Form.Group>
                    {Object.keys(columns).map((columnName) => (
                      <Form.Check
                        key={columnName}
                        type="checkbox"
                        id={`checkbox-${columnName}`}
                        label={columns[columnName].text} // Display the column name using 'text' key
                        checked={visibleColumns[columnName] || false} // Use 'visible' key to control the checked state
                        onChange={() => toggleColumn(columnName)} // Toggle visibility on change
                      />
                    ))}
                  </Form.Group>
                </div>
              </ul>
            </div>
          </OverlayTrigger>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
            >
              <button id="Add-btn" onClick={handleAddNew}>
                <i className="fa fa-plus"></i> Add
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover rounded>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "25px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                {isSrNoRequired && <th>Sr.No</th>}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn =
                    /\b(date|on bench since|from|to)\b/i.test(
                      columns[columnName].text
                    );

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;
                  const isSelectColumn = columns[columnName].type === "Select";
                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const isLinkColumn = columns[columnName].type === "Link";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{ whiteSpace: "nowrap" }}
                        key={columnName}
                        onClick={
                          isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon)
                            ? () => handleSort(columnName)
                            : undefined
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-chevron-up"></i>
                                ) : (
                                  <i className="bi bi-chevron-down"></i>
                                )
                              ) : (
                                <i className="bi bi-chevron-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
                {isFileDownloadRequired && <th>#</th>}
              </tr>
            </thead>
            {isRequiredStatus ? (
              isApiStatus === 200 && currentData?.length != 0 ? (
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      {isCheckBoxRequired && (
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              !!selectedResource.find(
                                (o) => o.EmployeeID === item.EmployeeID
                              )
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e, item.EmployeeID, item)
                            }
                          />
                        </td>
                      )}
                      {isSrNoRequired && (
                        <td className="text-center">{index + 1}</td>
                      )}
                      {Object.keys(columns).map((columnName) => {
                        const isDateColumn =
                          /\b(date|on bench since|from|to)\b/i.test(
                            columns[columnName].text
                          );

                        const columnAlignment =
                          columns[columnName].align || "left";
                        const columnWidth = columns[columnName].width;

                        const isButtonColumn =
                          columns[columnName].type === "button";
                        const isModalColumn =
                          columns[columnName].type === "Modal";
                        const isImageColumn =
                          columns[columnName].type === "Image";
                        const isLinkColumn =
                          columns[columnName].type === "Link";
                        const isSelectColumn =
                          columns[columnName].type === "Select";
                        const isButtonName = columns[columnName].text;
                        const hasIcon = columns[columnName].icon;

                        return (
                          visibleColumns[columnName] &&
                          (item[columnName] !== null &&
                          item[columnName] !== undefined ? (
                            <OverlayTrigger
                              key={columnName}
                              placement="right"
                              overlay={
                                <Tooltip id={`tooltip-${columnName}`}>
                                  {isDateColumn
                                    ? formatDate(item[columnName])
                                    : item[columnName]}
                                </Tooltip>
                              }
                            >
                              <td
                                className={`text-${columnAlignment} text-truncate`}
                                style={{
                                  maxWidth: columnWidth || "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {isButtonColumn ? (
                                  <button
                                    className={`text-${columnAlignment} custom-btn`}
                                    onClick={() => handleBtn(columnName, item)}
                                  >
                                    {isButtonName}
                                  </button>
                                ) : hasIcon ? (
                                  <div
                                    className="d-flex align-items-center justify-content-center text-center"
                                    onClick={() =>
                                      handleIconClick(columnName, item)
                                    }
                                  >
                                    <span className="me-2">
                                      {icons[columns[columnName].icon]}
                                    </span>
                                    {item[columnName]}
                                  </div>
                                ) : isDateColumn ? (
                                  formatDate(item[columnName])
                                ) : isModalColumn ? (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="text-info text-decoration-none"
                                    onClick={() =>
                                      handleModalColumn(columnName, item)
                                    }
                                  >
                                    {" "}
                                    {item[columnName]}
                                  </a>
                                ) : isImageColumn ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        backgroundColor: "gray",
                                      }}
                                    ></div>
                                  </div>
                                ) : isLinkColumn ? (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="text-info text-decoration-none"
                                    // onClick={() =>
                                    //   console.log("LinkColumn",columnName, item)
                                    // }
                                    href={item.FilePath}
                                    target="_blank"
                                  >
                                    {" "}
                                    {item[columnName]}
                                  </a>
                                ) : isSelectColumn ? (
                                  <>
                                    <Select
                                      name={columnName} // Use unique column name
                                      onChange={(selectedOption, action) => {
                                        // Update the value of the selected option for this specific row and column
                                        handleColumnSelect(
                                          selectedOption,
                                          item
                                        );

                                        // Update the state for the current row and column
                                        setDropdownValue((prevState) => ({
                                          ...prevState,
                                          [item.ID]: {
                                            // Use item.id (or any unique identifier for the row)
                                            ...prevState[item.ID],
                                            [columnName]: selectedOption, // Update only for this column of the current row
                                          },
                                        }));
                                      }}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      value={
                                        dropDownValue[item.ID]?.[columnName] || // Get value for this specific row and column
                                        columns[columnName].option?.find(
                                          (o) => o.value === item[columnName]
                                        ) || { value: null, label: "Select" }
                                      }
                                      options={[
                                        { value: null, label: "Select" },
                                        ...columns[columnName].option,
                                      ]}
                                    />
                                  </>
                                ) : (
                                  item[columnName]
                                )}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              key={columnName}
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "60px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                // <OverlayTrigger
                                //   placement="bottom"
                                //   overlay={
                                //     <Tooltip id="tooltip-bottom">
                                //       {item[columns[columnName].iconText] || "Edit"}
                                //     </Tooltip>
                                //   }
                                // >
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() =>
                                    handleIconClick(columnName, item)
                                  }
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : // </OverlayTrigger>
                              isDateColumn ? (
                                formatDate(item[columnName])
                              ) : (
                                item[columnName]
                              )}
                            </td>
                          ))
                        );
                      })}

                      {isActionRequired && (
                        <td>
                          <div className="d-flex justify-content-center text-center">
                            {showIcon1 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon1Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    Array.isArray(icons?.Icon1Flag) &&
                                    icons?.Icon1Flag.some(
                                      (flag) =>
                                        item[flag] === 0 || item[flag] === false
                                    )
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (
                                      !icons?.Icon1Flag?.some(
                                        (flag) =>
                                          item[flag] === 0 ||
                                          item[flag] === false
                                      )
                                    ) {
                                      handleIcon1(item);
                                    }
                                  }}
                                >
                                  {icons.Icon1}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon2 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon2Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  // className='me-2'
                                  // onClick={() => handleIcon2(item)}

                                  // className={`me-2 ${
                                  //   item[icons.Icon2Flag] === 0
                                  //     ? "disabled-icon"
                                  //     : ""
                                  // }`}
                                  className={`me-2 ${
                                    item[icons.Icon2Flag] === 0 ||
                                    item[icons.Icon2Flag] === false
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  // onClick={() => {
                                  //   if (item[icons.Icon2Flag] !== 0)
                                  //     handleIcon2(item);
                                  // }}
                                  onClick={() => {
                                    if (
                                      item[icons.Icon2Flag] !== 0 ||
                                      item[icons.Icon2Flag] !== false
                                    ) {
                                      handleIcon2(item);
                                    }
                                  }}
                                >
                                  {icons.Icon2}
                                </div>
                              </OverlayTrigger>
                            )}
                                {showIcon3 && (
  <OverlayTrigger
    placement="bottom"
    overlay={
      <Tooltip id="tooltip-bottom">
        {icons.Icon3Text}
      </Tooltip>
    }
  >
    <div
      className={`me-2 ${
        item[icons.Icon3Flag] !== 826 ? "disabled-icon" : ""
      }`}
      onClick={() => {
        if (item[icons.Icon3Flag] === 826) {
          handleIcon3(item);
        }
      }}
    >
      {icons.Icon3}
    </div>
  </OverlayTrigger>
)}
                            {showIcon4 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon4Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon4Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon4Flag] !== 0)
                                      handleIcon4(item);
                                  }}
                                >
                                  {icons.Icon4}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon5 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon5Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon5Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon5Flag] !== 0)
                                      handleIcon5(item);
                                  }}
                                >
                                  {icons.Icon5}
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      )}
                    {isFileDownloadRequired && currentData.length > 0 && (
  <td>
    <div className="d-flex justify-content-center text-center">
      {item.FilePath || item.FileName ? (
        item.FileName ? ( // Only show tooltip if FileName exists (icon is enabled)
          <OverlayTrigger
            key={index}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-file-${index}`}>
               Attachment
              </Tooltip>
            }
          >
            <div>
              <a
                className="me-2 text-center"
                href={item.FilePath || item.FileName}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-file-earmark-fill" style={{color:"#2e2e48"}}></i>
              </a>
            </div>
          </OverlayTrigger>
        ) : (
        "-"
        )
      ) : (
        <span>-</span> 
      )}
    </div>
  </td>
)}
                    </tr>
                  ))}
               <tr>
  {Object.keys(columns).map((columnName) => {
    // Only process if column is visible
    if (!visibleColumns[columnName]) {
      return <td key={columnName} style={{ display: 'none' }}></td>;
    }

    const sumValue = filteredData.reduce(
      (acc, item) => acc + (parseFloat(item[columnName]) || 0),
      0
    );

    if (
      ["AdvanceAmountBASE", "ApprovedAmountBASE", "TotalExpense", "BalanceAmountBASE"].includes(columnName)
    ) {
      return (
        <td key={columnName} className="text-end">
          <strong>Total: {sumValue.toFixed(2)}</strong>
        </td>
      );
    }

    return <td key={columnName}></td>;
  })}

  {/* Empty cells for action/checkbox columns if they exist */}
  {isCheckBoxRequired && <td></td>}
  {isActionRequired && <td></td>}
  {isFileDownloadRequired && <td></td>}
</tr>

                </tbody>
              ) : isApiStatus === 200 && currentData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isFileDownloadRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              ) : (
                isApiStatus === undefined && currentData?.length === 0 ?

               ( <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isFileDownloadRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                     <div>
                      <p>
                        <FaSpinner class="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                    </td>
                  </tr>
                </tbody>):
                (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isFileDownloadRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>)
              )
            ) : currentData?.length != 0 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            !!selectedResource.find(
                              (o) => o.EmployeeID === item.EmployeeID
                            )
                          }
                          onChange={(e) =>
                            handleCheckboxChange(e, item.EmployeeID, item)
                          }
                        />
                      </td>
                    )}
                    {isSrNoRequired && (
                      <td className="text-center">{index + 1}</td>
                    )}
                    {Object.keys(columns).map((columnName) => {
                      const isDateColumn =
                        /\b(date|on bench since|from|to)\b/i.test(
                          columns[columnName].text
                        );

                      const columnAlignment =
                        columns[columnName].align || "left";
                      const columnWidth = columns[columnName].width;

                      const isButtonColumn =
                        columns[columnName].type === "button";
                      const isModalColumn =
                        columns[columnName].type === "Modal";
                      const isImageColumn =
                        columns[columnName].type === "Image";
                      const isLinkColumn = columns[columnName].type === "Link";
                      const isSelectColumn =
                        columns[columnName].type === "Select";
                      const isButtonName = columns[columnName].text;
                      const hasIcon = columns[columnName].icon;

                      return (
                        visibleColumns[columnName] &&
                        (item[columnName] !== null &&
                        item[columnName] !== undefined ? (
                          <OverlayTrigger
                            key={columnName}
                            placement="right"
                            overlay={
                              <Tooltip id={`tooltip-${columnName}`}>
                                {isDateColumn
                                  ? formatDate(item[columnName])
                                  : item[columnName]}
                              </Tooltip>
                            }
                          >
                            <td
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() =>
                                    handleIconClick(columnName, item)
                                  }
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : isDateColumn ? (
                                formatDate(item[columnName])
                              ) : isModalColumn ? (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="text-info text-decoration-none"
                                  onClick={() =>
                                    handleModalColumn(columnName, item)
                                  }
                                >
                                  {" "}
                                  {item[columnName]}
                                </a>
                              ) : isImageColumn ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      backgroundColor: "gray",
                                    }}
                                  ></div>
                                </div>
                              ) : isLinkColumn ? (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="text-info text-decoration-none"
                                  // onClick={() =>
                                  //   console.log("LinkColumn",columnName, item)
                                  // }
                                  href={item.FilePath}
                                  target="_blank"
                                >
                                  {" "}
                                  {item[columnName]}
                                </a>
                              ) : isSelectColumn ? (
                                <>
                                  <Select
                                    name={columnName} // Use unique column name
                                    onChange={(selectedOption, action) => {
                                      // Update the value of the selected option for this specific row and column
                                      handleColumnSelect(selectedOption, item);

                                      // Update the state for the current row and column
                                      setDropdownValue((prevState) => ({
                                        ...prevState,
                                        [item.ID]: {
                                          // Use item.id (or any unique identifier for the row)
                                          ...prevState[item.ID],
                                          [columnName]: selectedOption, // Update only for this column of the current row
                                        },
                                      }));
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    value={
                                      dropDownValue[item.ID]?.[columnName] || // Get value for this specific row and column
                                      columns[columnName].option?.find(
                                        (o) => o.value === item[columnName]
                                      ) || { value: null, label: "Select" }
                                    }
                                    options={[
                                      { value: null, label: "Select" },
                                      ...columns[columnName].option,
                                    ]}
                                  />
                                </>
                              ) : (
                                item[columnName]
                              )}
                            </td>
                          </OverlayTrigger>
                        ) : (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`}
                            style={{
                              maxWidth: columnWidth || "60px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {isButtonColumn ? (
                              <button
                                className={`text-${columnAlignment} custom-btn`}
                                onClick={() => handleBtn(columnName, item)}
                              >
                                {isButtonName}
                              </button>
                            ) : hasIcon ? (
                              // <OverlayTrigger
                              //   placement="bottom"
                              //   overlay={
                              //     <Tooltip id="tooltip-bottom">
                              //       {item[columns[columnName].iconText] || "Edit"}
                              //     </Tooltip>
                              //   }
                              // >
                              <div
                                className="d-flex align-items-center justify-content-center text-center"
                                onClick={() =>
                                  handleIconClick(columnName, item)
                                }
                              >
                                <span className="me-2">
                                  {icons[columns[columnName].icon]}
                                </span>
                                {item[columnName]}
                              </div>
                            ) : // </OverlayTrigger>
                            isDateColumn ? (
                              formatDate(item[columnName])
                            ) : (
                              item[columnName]
                            )}
                          </td>
                        ))
                      );
                    })}

                    {isActionRequired && (
                      <td>
                        <div className="d-flex justify-content-center text-center">
                          {showIcon1 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon1Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  Array.isArray(icons?.Icon1Flag) &&
                                  icons?.Icon1Flag.some(
                                    (flag) =>
                                      item[flag] === 0 || item[flag] === false
                                  )
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (
                                    !icons?.Icon1Flag?.some(
                                      (flag) =>
                                        item[flag] === 0 || item[flag] === false
                                    )
                                  ) {
                                    handleIcon1(item);
                                  }
                                }}
                              >
                                {icons.Icon1}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon2 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon2Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                // className='me-2'
                                // onClick={() => handleIcon2(item)}

                                // className={`me-2 ${
                                //   item[icons.Icon2Flag] === 0
                                //     ? "disabled-icon"
                                //     : ""
                                // }`}
                                className={`me-2 ${
                                  item[icons.Icon2Flag] === 0 ||
                                  item[icons.Icon2Flag] === false
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                // onClick={() => {
                                //   if (item[icons.Icon2Flag] !== 0)
                                //     handleIcon2(item);
                                // }}
                                onClick={() => {
                                  if (
                                    item[icons.Icon2Flag] !== 0 ||
                                    item[icons.Icon2Flag] !== false
                                  ) {
                                    handleIcon2(item);
                                  }
                                }}
                              >
                                {icons.Icon2}
                              </div>
                            </OverlayTrigger>
                          )}
                         {showIcon3 && (
  <OverlayTrigger
    placement="bottom"
    overlay={
      <Tooltip id="tooltip-bottom">
        {icons.Icon3Text}
      </Tooltip>
    }
  >
    <div
      className={`me-2 ${
        item[icons.Icon3Flag] !== 826 ? "disabled-icon" : ""
      }`}
      onClick={() => {
        if (item[icons.Icon3Flag] === 826) {
          handleIcon3(item);
        }
      }}
    >
      {icons.Icon3}
    </div>
  </OverlayTrigger>
)}
                          {showIcon4 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon4Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item[icons.Icon4Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (item[icons.Icon4Flag] !== 0)
                                    handleIcon4(item);
                                }}
                              >
                                {icons.Icon4}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon5 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon5Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item[icons.Icon5Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (item[icons.Icon5Flag] !== 0)
                                    handleIcon5(item);
                                }}
                              >
                                {icons.Icon5}
                              </div>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    )}
                   {isFileDownloadRequired && currentData.length > 0 && (
  <td>
    <div className="d-flex justify-content-center text-center">
      {item.FilePath || item.FileName ? (
        item.FileName ? ( // Only show tooltip if FileName exists (icon is enabled)
          <OverlayTrigger
            key={index}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-file-${index}`}>
               Attachment
              </Tooltip>
            }
          >
            <div>
              <a
                className="me-2"
                href={item.FilePath || item.FileName}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-file-earmark-fill " style={{color:"#2e2e48"}}></i>
              </a>
            </div>
          </OverlayTrigger>
        ) : (
          // If FileName is empty (disabled icon), render without tooltip
          <div>
            <a
              className="me-2 disabled-icon"
              href={item.FilePath || item.FileName}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-download" style={{color:"#2e2e48"}}></i>
            </a>
          </div>
        )
      ) : (
        <span>-</span> 
      )}
    </div>
  </td>
)}
                  </tr>
                ))}
         <tr>
  {Object.keys(columns).map((columnName) => {
    // Only process if column is visible
    if (!visibleColumns[columnName]) {
      return <td key={columnName} style={{ display: 'none' }}></td>;
    }

    const sumValue = filteredData.reduce(
      (acc, item) => acc + (parseFloat(item[columnName]) || 0),
      0
    );

    if (
      ["AdvanceAmountBASE", "ApprovedAmountBASE", "TotalExpense", "BalanceAmountBASE"].includes(columnName)
    ) {
      return (
        <td key={columnName} className="text-end">
          <strong>Total: {sumValue.toFixed(2)}</strong>
        </td>
      );
    }

    return <td key={columnName}></td>;
  })}

  {/* Empty cells for action/checkbox columns if they exist */}
  {isCheckBoxRequired && <td></td>}
  {isActionRequired && <td></td>}
  {isFileDownloadRequired && <td></td>}
</tr>

              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0) +
                      (isSrNoRequired ? 1 : 0) +
                      (isFileDownloadRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        <FaSpinner class="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredData.length}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default ReimburseComponent;
